import { getAiAPI } from "./ai.mjs";
import { getDictionaryAPI } from "./dictionary.mjs";
import { getEditorAPI } from "./editor.mjs";
import { getNewsletterAPI } from "./newsletter.mjs";
import { getOAuthAPI } from "./oAuth.mjs";
import { getOrganizationAPI } from "./organization.mjs";
import { getProjectAPI } from "./project.mjs";
import { getSearchAPI } from "./search.mjs";
import { getStripeAPI } from "./stripe.mjs";
import { getTagAPI } from "./tag.mjs";
import { getUserAPI } from "./user.mjs";
const getIntlayerAPI = (authAPIOptions = {}, intlayerConfig) => ({
  organization: getOrganizationAPI(authAPIOptions, intlayerConfig),
  project: getProjectAPI(authAPIOptions, intlayerConfig),
  user: getUserAPI(authAPIOptions, intlayerConfig),
  oAuth: getOAuthAPI(intlayerConfig),
  dictionary: getDictionaryAPI(authAPIOptions, intlayerConfig),
  stripe: getStripeAPI(authAPIOptions, intlayerConfig),
  ai: getAiAPI(authAPIOptions, intlayerConfig),
  tag: getTagAPI(authAPIOptions, intlayerConfig),
  search: getSearchAPI(authAPIOptions, intlayerConfig),
  editor: getEditorAPI(authAPIOptions, intlayerConfig),
  newsletter: getNewsletterAPI(authAPIOptions, intlayerConfig)
});
export {
  getIntlayerAPI
};
//# sourceMappingURL=index.mjs.map